<template>
  <div class="wrapper page-splash">  
    <div class="logo-page-splash page-splash_breathing" v-if="logo && logo.url">
      <img
        :src="logo.url"
        alt="logo-azul"
        class="page-splash_img"
      />
    </div>
  </div>
</template>

<script>
  export default {
    name: "view-login",
    data() {
      return {
        logo: this.imagens.find((img) => img.nome === "logo_colorida_512x512"),
      };
    }
  }
</script>
